module.exports = __webpack_public_path__ + "img/GEBBeograd.da24ea20.png";